import script from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=e64b43ea&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e64b43ea"]])

export default __exports__